import { Outlet } from "react-router-dom";
import React, { useEffect } from "react";
import * as styles from "./Layout.module.css";
import SideBar from "../SideBar";

const Layout = ({ userData }) => {
  return (
    <div className={styles.layoutWrapper}>
      <div className={styles.mainPanel}></div>
      <div className={`${styles.layoutContainer} blur_card`}>
        <SideBar />
        <main className={styles.mainContent}>
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default Layout;
